"use client"
import {Link, useNavigate} from 'react-router-dom';
import { useState, useEffect } from "react"
import { ArrowLeft, Check, Eye, EyeOff, KeyRound, Lock } from "lucide-react"
import { useTheme } from "../../../../../redux/hooks/useTheme";
import { useUserDetails, useUpdateUserDetails } from "../../../../../redux/hooks/UserDetails";
import Sidebar from './Sidebar';
import BuilderService from '../../../../services/BuilderService';
import { toast } from 'react-toastify';
import './GeneralSettings.css'
import Header from '../Header';
import Footer from '../Footer';

export default function GeneralSettings() {
  const [showOldPassword, setShowOldPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [oldPassword, setOldPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [isUpdating, setIsUpdating] = useState(false)
  const [isUpdatingPassword, setIsUpdatingPassword] = useState(false)
  const [hasNameBeenClicked, setHasNameBeenClicked] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: ""
  })
  const { theme } = useTheme();
  const { userDetail } = useUserDetails();
  const { updateUserDetail } = useUpdateUserDetails();
  const navigate = useNavigate();
  const builderService = new BuilderService();

  useEffect(() => {
    if (userDetail?.ogUserId) {
      navigate("*");
    }
  }, [userDetail, navigate]);

  // Password validation checks
  const hasLowercase = /[a-z]/.test(newPassword);
  const hasUppercase = /[A-Z]/.test(newPassword);
  const hasNumber = /[0-9]/.test(newPassword);
  const hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(newPassword);
  const hasMinLength = newPassword.length >= 8;
  const passwordsMatch = newPassword === confirmPassword && confirmPassword !== "";

  // Extract user details with default values
  const {
    name = "N/A",
    email = "N/A",
    ogCompanyName = "N/A",
    ogUser = false,
    isGoogleAuth = false,

  } = userDetail || {};
console.log("userDetails",userDetail)
  // Update form data when userDetail changes
  useEffect(() => {
    if (userDetail) {
      
      setFormData({
        
        name: userDetail.name || "N/A",
        email: userDetail.email || "N/A",
        company: userDetail.ogCompanyName || "N/A"
      });
    }
  }, [userDetail]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleNameFieldClick = () => {
    setHasNameBeenClicked(true);
  };

  const handleUpdateChanges = async () => {
    try {
      setIsUpdating(true);
      const response = await builderService.updateUserDetails({
        email: formData.email,
        name: formData.name,
        companyName: formData.company
      });

      if (response.success) {
        // Update the Redux store with new user details
console.log("response",response.data.user);
        // We only want to update the flat fields, and keep the populated nested objects like ogSubscriptionId
        updateUserDetail({
          ...userDetail,
          ...response.data.user,
          ogSubscriptionId: userDetail.ogSubscriptionId // Preserve the populated subscription
        });
        toast.success('Profile updated successfully');
      } else {
        toast.error(response.message || 'Failed to update profile');
      }
    } catch (error: any) {
      toast.error(error.response?.data?.message || 'Error updating profile');
    } finally {
      setIsUpdating(false);
    }
  };

  const handleUpdatePassword = async () => {
    if (isUpdatingPassword) return;
    try {
      setIsUpdatingPassword(true);
      const payload: any = {
        email: userDetail.email,
        newPassword,
      };
      if (!isGoogleAuth) {
        payload.oldPassword = oldPassword;
      }
      const response = await builderService.updateUserPassword(payload);

      if (response.success) {
        updateUserDetail(response.data.user);
        toast.success(response.message || 'Password updated successfully');
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
        window.location.href = '/login';
       
      }else {
        toast.error(response.message || 'Failed to update password');
      }
    } catch (error: any) {
      const backendMessage =

      error?.response?.message ||
      error?.message ||
      'Error updating password';

    toast.error(backendMessage);
    } finally {
      setIsUpdatingPassword(false);
    }
  };


  return (
   <>
     <Header noPadding={true} addBottomBorder={true} isDifferentStyle={true} paddingTop={true} hideBorder paddingX={true} paddingY={true}  />
     <div className='userprofile-bg'>
        

          {/* Main content */}
          <div style={{}} className="mx-auto px-[10px] billing billing-mob pb-[40px]">
            <div className="flex flex-col md:flex-row gap-[16px] tab-flex">
              <Sidebar/>
            
              {/* Main form area */}
              <div className="flex-1 grid md:grid-cols-2 gap-[16px] pt-[40px]">
                {/* Account section */}
                <div className="bg-transparent rounded-lg ">
                  <h2 className="text-xl font-medium mb-[14px]">Account</h2>
                  <div style={{}} className='p-[20px] rounded-[20px] border general-bordre general-cards'>
                  <div className="space-y-6 ">
                    <div>
                      <label htmlFor="name" className="block uppercase tracking-wide general-label mb-2">
                        NAME
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        onClick={handleNameFieldClick}
                        disabled={ogUser}
                        className="w-full px-4 py-3 rounded-[8px] border general-inputbg general-bordre focus:border-pink-500"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block uppercase tracking-wide general-label mb-2">
                        EMAIL
                      </label>
                      <div className="relative">
                        {/* <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          readOnly
                          className="w-full px-4 py-3 rounded-[8px] border general-inputbg general-bordre cursor-not-allowed text-[#666666a8]"
                        />
                       */}
                       <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        readOnly
                        className={`
                          w-full px-4 py-3 rounded-[8px] border general-inputbg general-bordre 
                          cursor-not-allowed text-[#666666a8]
                          ${formData.email ? "input-blur" : ""}
                        `}
                      />
                      </div>
                    </div>
                    {/* <div>
                      <label htmlFor="company" className="block text-xs uppercase tracking-wide text-gray-500 mb-2">
                        COMPANY
                      </label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleInputChange}
                        disabled={ogUser}
                        className="w-full px-4 py-3 rounded-md border border-gray-200 bg-gray-50 focus:outline-none focus:ring-1 focus:ring-pink-500 focus:border-pink-500"
                      />
                    </div> */}
                    {!ogUser && (
                      <div>
                        <button 
                          className="px-6 py-3 text-white rounded-[12px] genrl-bt transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          style={{ color: theme.buttonTextColor, fontSize:'14px',fontWeight:600 }}
                          onClick={handleUpdateChanges}
                          disabled={isUpdating || !hasNameBeenClicked}
                        >
                          {isUpdating ? 'Updating...' : 'Update Changes'}
                        </button>
                      </div>
                    )}
                  </div>
                  </div>
                </div>

                {/* Password section - only show if not ogUser */}
                {!ogUser && (
                  <div className="bg-transparent rounded-lg ">
                    <h2 className="general-shd mb-[15px]">Password</h2>
                  <div style={{}} className='border general-bordre p-[20px] rounded-[20px] general-cards'>
                  <div className="space-y-6">
                      {/* Only show Old Password if not Google Auth */}
                      {!isGoogleAuth && (
                        <div>
                          <label htmlFor="old-password" className="block uppercase tracking-wide general-label mb-2">
                            OLD PASSWORD
                          </label>
                          <div className="relative">
                            <div>
                              <div className="absolute spborder-r p-[14px] top-1/2 -translate-y-1/2 text-gray-400">
                              <span style={{color:theme.seIcon}}>
               
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.5 7.5V6C4.5 3.5175 5.25 1.5 9 1.5C12.75 1.5 13.5 3.5175 13.5 6V7.5" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M9 13.875C10.0355 13.875 10.875 13.0355 10.875 12C10.875 10.9645 10.0355 10.125 9 10.125C7.96447 10.125 7.125 10.9645 7.125 12C7.125 13.0355 7.96447 13.875 9 13.875Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12.75 16.5H5.25C2.25 16.5 1.5 15.75 1.5 12.75V11.25C1.5 8.25 2.25 7.5 5.25 7.5H12.75C15.75 7.5 16.5 8.25 16.5 11.25V12.75C16.5 15.75 15.75 16.5 12.75 16.5Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>

                              </span>
                            </div>
                              </div>
                            <input
                              type={showOldPassword ? "text" : "password"}
                              id="old-password"
                              value={oldPassword}
                              onChange={(e) => setOldPassword(e.target.value)}
                              placeholder="Old password"
                              className="w-full pl-[55px] general-holder pr-10 py-3 rounded-[8px] border general-inputbg general-bordre focus:border-pink-500"
                            />
                            <button
                              type="button"
                              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                              onClick={() => setShowOldPassword(!showOldPassword)}
                            >
                              {showOldPassword ? <Eye style={{color:theme.seIcon}} className="w-5 h-5 sidebar-icon" />: <EyeOff style={{color:theme.seIcon}} className="w-5 h-5 sidebar-icon" />}
                            </button>
                          </div>
                         
                        </div>
                      )}

                      {/* New Password */}
                      <div>
                        <label htmlFor="new-password" className="block uppercase tracking-wide general-label mb-2">
                          NEW PASSWORD
                        </label>
                        <div className="relative">
                          <div className="absolute spborder-r p-[14px]  top-1/2 -translate-y-1/2 text-gray-400">
                            <span style={{color:theme.seIcon}}>
               
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.5 7.5V6C4.5 3.5175 5.25 1.5 9 1.5C12.75 1.5 13.5 3.5175 13.5 6V7.5" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 13.875C10.0355 13.875 10.875 13.0355 10.875 12C10.875 10.9645 10.0355 10.125 9 10.125C7.96447 10.125 7.125 10.9645 7.125 12C7.125 13.0355 7.96447 13.875 9 13.875Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12.75 16.5H5.25C2.25 16.5 1.5 15.75 1.5 12.75V11.25C1.5 8.25 2.25 7.5 5.25 7.5H12.75C15.75 7.5 16.5 8.25 16.5 11.25V12.75C16.5 15.75 15.75 16.5 12.75 16.5Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                            </span>
                          </div>
                          <input
                            type={showNewPassword ? "text" : "password"}
                            id="new-password"
                            value={newPassword}
                            placeholder="New password"
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="w-full pl-[55px]  pr-10 py-3 general-holder rounded-[8px] border general-inputbg general-bordre focus:border-pink-500"
                          />
                          <button
                            type="button"
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                            onClick={() => setShowNewPassword(!showNewPassword)}
                          >
                            {showNewPassword ?   <Eye style={{color:theme.seIcon}} className="w-5 h-5 sidebar-icon" />:<EyeOff style={{color:theme.seIcon}} className="w-5 h-5 sidebar-icon" /> }
                          </button>
                        </div>
                        {/* <div className="grid grid-cols-2 gap-2 mt-2">
                          <div className="flex items-center text-sm text-gray-600">
                            <div className={`w-5 h-5 rounded-full flex items-center justify-center ${hasLowercase ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-400"}`}>
                              {hasLowercase && "✓"}
                            </div>
                            <span className="ml-2 password-validation">one lowercase character</span>
                          </div>
                          <div className="flex items-center text-sm text-gray-600">
                            <div className={`w-5 h-5 rounded-full flex items-center justify-center ${hasSpecial ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-400"}`}>
                              {hasSpecial && "✓"}
                            </div>
                            <span className="ml-2 password-validation">one special character</span>
                          </div>
                          <div className="flex items-center text-sm text-gray-600">
                            <div className={`w-5 h-5 rounded-full flex items-center justify-center ${hasUppercase ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-400"}`}>
                              {hasUppercase && "✓"}
                            </div>
                            <span className="ml-2 password-validation">one uppercase character</span>
                          </div>
                          <div className="flex items-center text-sm text-gray-600">
                            <div className={`w-5 h-5 rounded-full flex items-center justify-center ${hasMinLength ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-400"}`}>
                              {hasMinLength && "✓"}
                            </div>
                            <span className="ml-2 password-validation">8 min character</span>
                          </div>
                          <div className="flex items-center text-sm text-gray-600">
                            <div className={`w-5 h-5 rounded-full flex items-center justify-center ${hasNumber ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-400"}`}>
                              {hasNumber && "✓"}
                            </div>
                            <span className="ml-2 password-validation">one number</span>
                          </div>
                        </div> */}
                          <div className="grid grid-cols-2 mt-[10px] gap-2 mb-[18px]">
              <div className="flex items-center gap-2">
                <div
                  className={`h-[16px] w-[16px] rounded-full flex items-center justify-center ${hasLowercase ? " text-green-600" : " text-gray-400"}`}
                >
                  <CheckIcon checked={hasLowercase} />
                </div>
                <span style={{fontWeight:400, textAlign:'left' }} className="s-suggestion font-inter text-[12px] sugg-mob">One lowercase character</span>
              </div>
              <div className="flex items-center gap-2">
                <div
                  className={`h-[16px] w-[16px] rounded-full flex items-center justify-center ${hasSpecial ? " text-green-600" : " text-gray-400"}`}
                >
                  <CheckIcon checked={hasSpecial} />
                </div>
                <span style={{fontWeight:400, textAlign:'left' }} className="s-suggestion font-inter text-[12px] sugg-mob">One special character</span>
              </div>
              <div className="flex items-center gap-2">
                <div
                  className={`h-[16px] w-[16px] rounded-full flex items-center justify-center ${hasUppercase ? " text-green-600" : " text-gray-400"}`}
                >
                <CheckIcon checked={hasUppercase} />
                </div>
                <span style={{fontWeight:400, textAlign:'left' }} className="s-suggestion font-inter text-[12px] sugg-mob">One uppercase character</span>
              </div>
              <div className="flex items-center gap-2">
                <div
                  className={`h-[16px] w-[16px] rounded-full flex items-center justify-center ${hasMinLength ? " text-green-600" : " text-gray-400"}`}
                >
                <CheckIcon checked={hasMinLength} />
                </div>
                <span style={{fontWeight:400, textAlign:'left' }} className="s-suggestion font-inter text-[12px] sugg-mob">Min 8 characters</span>
              </div>
              <div className="flex items-center gap-2">
                <div
                  className={`h-[16px] w-[16px] rounded-full flex items-center justify-center ${hasNumber ? " text-green-600" : " text-gray-400"}`}
                >
                <CheckIcon checked={hasNumber} />
                </div>
                <span style={{fontWeight:400, textAlign:'left' }} className="s-suggestion font-inter text-[12px] sugg-mob">One number</span>
              </div>
            </div>
                      </div>

                      {/* Confirm New Password */}
                      <div>
                        <label
                          htmlFor="confirm-password"
                          className="block uppercase tracking-wide general-label mb-2"
                        >
                          CONFIRM NEW PASSWORD
                        </label>
                        <div className="relative">
                          <div className="absolute spborder-r p-[14px] top-1/2 -translate-y-1/2 text-gray-400">
                            <span style={{color:theme.seIcon}}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.5 7.5V6C4.5 3.5175 5.25 1.5 9 1.5C12.75 1.5 13.5 3.5175 13.5 6V7.5" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 13.875C10.0355 13.875 10.875 13.0355 10.875 12C10.875 10.9645 10.0355 10.125 9 10.125C7.96447 10.125 7.125 10.9645 7.125 12C7.125 13.0355 7.96447 13.875 9 13.875Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12.75 16.5H5.25C2.25 16.5 1.5 15.75 1.5 12.75V11.25C1.5 8.25 2.25 7.5 5.25 7.5H12.75C15.75 7.5 16.5 8.25 16.5 11.25V12.75C16.5 15.75 15.75 16.5 12.75 16.5Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            </span>
                          </div>
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm new password"
                            id="confirm-password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className={`w-full pl-[55px] general-holder  pr-10 py-3  rounded-[8px] border ${
                              confirmPassword ? (passwordsMatch ? "border-green-500" : "border-red-500") : "border-gray-200"
                            } general-inputbg general-bordre focus:border-pink-500`}
                          />
                          <button
                            type="button"
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          >
                            {showConfirmPassword ?   <Eye style={{color:theme.seIcon}} className="w-5 h-5 sidebar-icon" /> : <EyeOff style={{color:theme.seIcon}} className="w-5 h-5 sidebar-icon" />}
                          </button>
                        </div>
                        {confirmPassword && !passwordsMatch && (
                          <p className="text-red-500 text-sm mt-1">Passwords do not match</p>
                        )}
                      </div>

                      {/* Update Button */}
                      <div>
                        <button 
                          className="px-6 py-3 rounded-[12px] genrl-bt hover:bg-pink-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                          style={{color: theme.buttonTextColor,  fontSize:'14px', fontWeight:600}}
                          onClick={handleUpdatePassword}
                          disabled={
                            isUpdatingPassword ||
                            !passwordsMatch ||
                            !(hasLowercase && hasUppercase && hasNumber && hasSpecial && hasMinLength) ||
                            (!isGoogleAuth && !oldPassword)
                          }
                        >
                          {isUpdatingPassword ? (isGoogleAuth ? 'Setting Password...' : 'Updating Password...') : (isGoogleAuth ? 'Set Password' : 'Change Password')}
                        </button>
                      </div>
                    </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <Footer/>
      </div>
     
   </>  
  )
}


// Custom check icon component
function CheckIcon({ checked, }: { checked: boolean }) {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    stroke={ checked  ? "#00875a" : "#666666"} // Green if checked, gray if not
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9 12l2 2 4-4" />
  </svg>
  );
}